import { FirebasePortalData } from '@oy/types';

export const DEFAULT_FIREBASE_DATA: FirebasePortalData = {
  bulkDisbursement: {
    bulkCreateV2: {
      batchConcurrentBase: 1000,
      batchIntervalms: 5000,
      batchMaxAttempt: 3,
      batchMaxConcurrent: 4,
      batchSingleSize: 100,
      batchWorker: 3,
      sendInstructionDelay: 5000,
    },
    bulkPriorityQueue: {
      smallQueueLimit: 100,
    },
    bulkValidationV2: {
      batchConcurrentBase: 5000,
      batchIntervalms: 5000,
      batchMaxAttempt: 3,
      batchMaxConcurrent: 4,
      batchSingleSize: 100,
      batchWorker: 3,
    },
    bankJsonFlag: true,
    cacheBulkList: true,
    fullReleasePricing: false,
    whitelistCreateSerial: '',
    whitelistPriorityQueue: '',
    whitelistSimplifiedBoolean: '',
    whitelistValidateSerial: '',
    whitelistPricing: '',
    whitelistKeyName: '',
    whitelistSubEntity: '',
    downloadTimeout: 0,
    keyNameSanitized: '',
    isReadjustActive: false,
    isApprovalRelease: true,
    showVendorMaintenance: false,
    showSubEntity: false,
  },
  apiDisbursement: {
    whitelistExport: '',
    whitelistReceipt: '',
    showVendorMaintenance: false,
  },
  manualTopup: {
    underMaintenance: '',
  },
  vaTopup: {
    underMaintenance: '008',
  },
  manualWithdrawal: {
    underMaintenance: '',
  },
  notification: {
    showVendorMaintenance: false,
  },
  i18n: {
    isSofActive: false,
  },
  autoReport: {
    disbursement: false,
  },
  refundReport: {
    activeProducts:
      'API_DISBURSE,BULK_DISBURSEMENT,CLAIM_FUND,API_INQUIRY,INTERNATIONAL_TRANSFER,PAYMENT_ROUTING',
  },
};
